import { Company_BASE, ICompany_Field, ICompany_Key, ICompany_Insert } from './base/Company.base';
import {Injectable} from '@angular/core';
import {PersistentService, AgaveService, CadmoBetweenRange, CadmoOperator} from 'tq-agave';



export class Company extends Company_BASE {
    // i fields servono per cose come la cadmo-table e cadmo-form-field
    // Nelle nuove versioni di typescript vengono ereditati anche i campi statici
    // static fieldList = Company_BASE.fieldList;
    // static keyList: string[] = Company_BASE.keyList;
    // static updateFieldList: string[] = Company_BASE.updateFieldList;

    constructor(value?: any) { super(value); }

    between_creato_il_utc?: CadmoBetweenRange;
    between_modificato_il_utc?: CadmoBetweenRange;
    override getCadmoOperators(): any {
        const operators = super.getCadmoOperators();
        // Metti qui sotto gli operatori custom
        if (this.between_creato_il_utc?.start || this.between_creato_il_utc?.stop) {
            operators['_operator_creato_il_utc'] = CadmoOperator.BETWEEN;
            const {start, stop} = this.between_creato_il_utc;
            operators['_startvalue_creato_il_utc'] = start ? '' + AgaveService.getEpochFromDate(start) : undefined;
            operators['_stopvalue_creato_il_utc'] = stop ? '' + AgaveService.getEpochFromDate(stop) : undefined;
        }
        if (this.between_modificato_il_utc?.start || this.between_modificato_il_utc?.stop) {
            operators['_operator_modificato_il_utc'] = CadmoOperator.BETWEEN;
            const {start, stop} = this.between_modificato_il_utc;
            operators['_startvalue_modificato_il_utc'] = start ? '' + AgaveService.getEpochFromDate(start) : undefined;
            operators['_stopvalue_modificato_il_utc'] = stop ? '' + AgaveService.getEpochFromDate(stop) : undefined;
        }
        return operators;
    }
    override getCadmoInsertAction(): string {
        return 'json_rpc_insert_company';
    }

    getCadmoModifyAction(): string {
        return 'json_rpc_modify_confirm_con_imsign_group';
    }
}

export type ICompany = Company & ICompany_Field;

// Nota bene: se si tratta di una vista che ha una chiave primaria, puoi anche sostituire le interfacce nel generic con dei tipi piu' consoni
@Injectable({ providedIn: 'root' })
export class CompanyService extends PersistentService<Company, ICompany_Field, ICompany_Key, ICompany_Insert> {
    constructor(agaveService: AgaveService) { super(Company, agaveService); }
}

